import React, { useMemo } from 'react';
import type { PapiDeviation } from '@wix/da-papi-types';
import ThumbOverlayBackgroundDS from '@wix/da-ds/pkg/thumbs/legos/ThumbOverlayBackground';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
import { useDeviationBlockType } from '../../hooks/useDeviationBlockType';

interface Props {
  deviation: PapiDeviation;
  /** show background on hover even if there's no permanent overlay */
  showDefaultHover?: boolean;
  className?: string;
}

const ThumbOverlayBackground: React.FC<Props> = ({ deviation, className, showDefaultHover }) => {
  const blockType = useDeviationBlockType(deviation);

  const backgroundType: 'gradient' | 'solid' | undefined = useMemo(() => {
    // stuff that gets blurred images gets a gradient
    if (blockType) {
      return 'gradient';
    }
  }, [blockType]);

  if (backgroundType) {
    return <ThumbOverlayBackgroundDS type={backgroundType} className={className} />;
  }

  if (showDefaultHover) {
    return (
      <HoverOnly>
        <ThumbOverlayBackgroundDS type="gradient" className={className} />
      </HoverOnly>
    );
  }

  return null;
};
ThumbOverlayBackground.displayName = 'ThumbOverlayBackground';

export default ThumbOverlayBackground;
